import "./Banner.css";
import config from "../config";

const Banner = () => {
  const bannerMessage = config.BANNER_MESSAGE;

  if (!bannerMessage) return null;

  return (
    <div className="global-banner">
      <p className="banner-text">{bannerMessage || "Default banner message"}</p>
    </div>
  );
};

export default Banner;
